/*
RajeshK 09/19/2022 2700524332 Fixed GAL (136,137,158,98)
Sohel 09/20/2022 2700524332 Fixed GAL - 31,124,134,137,138,149,157,175
Poornima 09/22/2022 2700524332 role management sort issue
Adityaaa 09/27/2022 2700524332 Fixed Module drop down issue
Adityaaa 09/28/2022 2700524332 GAL_250, Role management module dropdown issue fixed
Ashraf 10/16/2022 2700524332 added code comments in search, add role management
Raghu 10/26/2022 2700524332 Table Alignment & Enhancements.
akhilaavvaru 10/27/2022 2700524332 role management UX changes
akhila 10/31/2022 2700524332 TablePagination bugFix
Dilip  11/02/2022 2700524332 added clickable functionality to role name
saikrishna 11/03/2022 2700524332 Changed paginationOptions
Prakash 11/03/2022 2700524332 Fixed Table Pagination.
Lalitha 11/08/2022 2700632669 Added span element in Column link
Ashraf 11/14/2022 2700632669 fixed page break issue
Raghu 11/29/2022 2700632669 Table Footer Styling Fixes
Akhila 12/09/2022 2700632669 fixed session saerch issue
Akhila 12/08/2022 3225736869 added session storage for search items
lalitha 12/08/2022 2700632669 Added Action column and edit icon.
Sohel 12/12/2022 2700524332 Implemented Copy Functionality
kavyareddy 12/12/2022 2700632669 Changed payload condition for isActive
kavyareddy 12/12/2022 2700632669 rename isActive to status
Sohel 12/12/2022 2700524332 Implemented System Notes
kavyareddy 12/13/2022 2700632669 Added Status data in table.
Sai Maheshwar 12/14/2022 3031450488 added save close for add user
Ashraf 12/15/2022 3031450488 fixed role based access
Dilip 12/22/2022 3031450488 bugFix session stoarge
Dilip 12/21/2022 3031450488 added styling to Role name
// Suresh Peddavoora 12/28/2022 3031450488 Fixed Role Description Table Column Spacing Alignments
 Suresh Peddavoora 02/24/2023 3031450488 New UI changes
suresh peddavoora 02/24/2023 3031450488 New UI changes added
Prakash 03/15/2023 3031450488 Added Menu Item Icons.
Prakash 03/16/2023 3031450488 Added Custom Action-Icons.
suresh peddavoora 03/16/2023 3031450488 Toolbar button Alignments
suresh peddavoora 04/03/2023 3031450488 add icon added
Dilip  04/07/2023 3031450488 disabled inactive fields
Sohel 04/17/2023 3031450488 Fixed Add Role Page Break Issue
Ravi  05/04/2023 3031450488 changed status bydefault to Active
Sohel 05/23/2023 2700539021 removed Module Field
Akhila 06/13/2023 2700539021 Added code and description
*/

import {Grid, Button, TablePagination} from '@material-ui/core';
// import MaterialTable from "material-table";
import React, {createRef, useState, useEffect} from 'react';
import {tableIcons} from '../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../constants/ReusableTablePagination';
import {httpPaginationPost} from '../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {fetchAddRoleData} from '../../../redux/reducers/RoleManagement/AddRole';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {makeStyles} from '@material-ui/core';
import RoleManagementSystemNotes from './SystemNotes';
import DialogBox from '../../../components/DialogBox';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../util/ActionMenuItem';
import AddIcon from '@material-ui/icons/AddOutlined';
import {MTableToolbar} from 'material-table';
// all existing roles table (2700524332)
const RoleManagementTable = ({
  searchData,
  submit,
  setSubmit,
  setValue,
  setRoleId,
  setModuleNames,
  setIsCopy,
  isCopy,
  isAddUser,
  company,
  tempSelectedRows,
  setTempSelectedRows,
  handleClose,
  selectedRows,
  setSelectedRows,
  tempUnCheckedRef,
}) => {
  const tableRef = createRef();

  const [rows, setRows] = useState(defaultRows);
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [isNote, setIsNote] = useState(false);
  const [roleName, setRoleName] = useState('');
  const useStyles = makeStyles((theme) => ({
    'link': {
      color: '#320469 !important',
      maxWidth: 165,
      textAlign: 'justify',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      borderBottom: '1px solid #000099',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();

  // to refresh table by recalling table api when search form submits (2700524332)
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef?.current?.onQueryChange() : '';
    }
  }, [searchData]);

  // resetting moduleName state when search tab is rendered (2700524332)
  useEffect(() => {
    setModuleNames([]);
  }, []);
  const handleNotesDialog = () => {
    setIsNote(false);
  };
  const handleEdit = (rowData) => {
    dispatch(fetchAddRoleData(rowData.roleId));
    setRoleId(rowData.roleId);
    setValue(1);
    const moduleArr = rowData?.moduleName?.split(',');
    const newModuleArr = moduleArr?.map((data) => data.trim());
    const finArr = newModuleArr.map((each) => {
      if (each === 'Business Rule Engine') {
        return 'Business Rule Engine';
      } else if (each === 'Custom WIndow') {
        return 'Custom Window';
      } else {
        return each;
      }
    });
    rowData?.moduleName !== 'null' && setModuleNames(finArr);
  };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setRoleName(rowData);
  };
  const handleCopy = (rowData) => {
    dispatch(fetchAddRoleData(rowData.roleId));
    setRoleId(rowData.roleId);
    setValue(1);
    setIsCopy(true);
    const moduleArr = rowData?.moduleName?.split(',');
    const newModuleArr = moduleArr?.map((data) => data.trim());
    const finArr = newModuleArr.map((each) => {
      if (each === 'Business Rule Engine') {
        return 'Business Rule Engine';
      } else if (each === 'Custom WIndow') {
        return 'Custom Window';
      } else {
        return each;
      }
    });
    rowData?.moduleName !== 'null' && setModuleNames(finArr);
  };
  const {roleData} = useSelector(({role}) => role);
  const roleAccess = roleData?.window?.['Role Management']?.['RMM'];

  const columns = [
    {
      title: 'Role Name',
      field: 'roleName',
      render: (rowData) => {
        if (!isAddUser) {
          return (
            <span
              role="button"
              className={classes1.link}
              onClick={() => {
                dispatch(fetchAddRoleData(rowData.roleId));
                setRoleId(rowData.roleId);
                setValue(1);
                const moduleArr = rowData?.moduleName?.split(',');
                const newModuleArr = moduleArr?.map((data) => data.trim());
                const finArr = newModuleArr.map((each) => {
                  if (each === 'Business Rule Engine') {
                    return 'Business Rule Engine';
                  } else if (each === 'Custom WIndow') {
                    return 'Custom Window';
                  } else {
                    return each;
                  }
                });
                rowData?.moduleName !== 'null' && setModuleNames(finArr);
              }}
            >
              {rowData?.roleName ? rowData.roleName.replace(/ /g, '\u00a0') : "" }
            </span>
          );
        } else {
          return rowData?.roleName ? rowData.roleName.replace(/ /g, '\u00a0') : "";
        }
      },
    },
    {
      title: 'Role Description',
      field: 'roleDescription',
      type: 'string',
      cellStyle: {
        maxWidth: '500px',
        wordBreak: 'break-word',
      },
      render: (rowData) => (
        <span style={{whiteSpace: 'pre-wrap'}}>{rowData.roleDescription ? rowData.roleDescription.replace(/ /g, '\u00a0') : ""}</span>
      ),
    },
    // {
    //   title: "Module",
    //   field: "moduleName",
    //   type: "string",
    //   render: (rowData) => (
    //     <>
    //       <MouseOverPopover data={rowData.moduleName} popOverData={rowData.moduleName} />
    //     </>
    //   ),
    // },
    {
      title: 'Company Code',
      field: 'companyCodeList',
      render: (rowData) => {
        if (rowData?.companyCodeList?.length === 1) {
          return rowData.companyCodeList;
        } else if (rowData?.companyCodeList?.length > 1) {
          return rowData?.companyCodeList?.reduce(
            (acc, item, index) =>
              index < rowData?.companyCodeList?.length - 1 ? acc + item + ', ' : acc + item + '',
            '',
          );
        }
      },
    },
    {
      title: 'Status',
      field: 'isActive',
      cellStyle: {minWidth: 200, textAlign: 'center'},
      headerStyle: {textAlign: 'center'},
      render: (rowData) =>
        rowData?.isActive === 'N' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>In Active</span>
          </div>
        ) : (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Active</span>
          </div>
        ),
    },
  ];
  useEffect(() => {
    isCopy && setIsCopy(false);
  }, []);
  return (
    <>
      <DialogBox
        open={isNote}
        dialogClose={handleNotesDialog}
        title="Role Management Notes"
        maxWidth="lg"
        hideFooter={true}
      >
        <RoleManagementSystemNotes roleName={roleName} />
      </DialogBox>
      <Grid item xs={12} className="role-table new-standard-textfields actions-dropdown-table">
        <div
          className="custom-table global-field-table"
          role="contentinfo"
          aria-label="custom-table-1"
        >
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `search/all/rolemgmt`;
                const searchSessionRoleManagement = JSON.parse(
                  sessionStorage.getItem('searchRoleManagement'),
                );
                if (searchSessionRoleManagement && !submit && !isAddUser) {
                  searchData = searchSessionRoleManagement;
                }
                const bodyObj = {
                  isActive: searchData?.isActive?.key ?
                    searchData?.isActive?.key === 'A' ?
                      '' :
                      searchData?.isActive?.key :
                    'Y',
                  moduleName:
                    searchData?.module?.length > 0 ?
                      searchData?.module?.map((item) =>
                        item.value === 'BRE' ? 'Business Rule Engine' : item?.value,
                      ) :
                      [],
                  companyCode: isAddUser ?
                    company :
                    searchData?.companyCode?.length > 0 ?
                      searchData?.companyCode :
                      [],
                  roleName: searchData?.roleName ? searchData?.roleName : '',
                  roleDescription: searchData?.roleDescription ? searchData?.roleDescription : '',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy:
                    query.orderBy && query.orderBy.field ?
                      query.orderBy?.field === 'companyCodeList' ?
                        'companyCode' :
                        query.orderBy?.field :
                      '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  search: '',
                };
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObject;
                      const newObj = {};
                      if (selectedRows) {
                        [...selectedRows, ...tempSelectedRows].forEach((el) => {
                          if (!newObj[el.roleName]) {
                            newObj[el.roleName] = el;
                          }
                        });
                      }
                      const newRows = data?.map((elem) => {
                        if (newObj[elem.roleName]) {
                          return {...elem, tableData: {...elem.tableData, checked: true}};
                        } else {
                          return {
                            ...elem,
                            tableData: {...elem.tableData, checked: false},
                          };
                        }
                      });
                      resolve({
                        data:
                          isAddUser && newRows?.length > 0 ? newRows : data.length > 0 ? data : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(data.length === 1);
                      setSubmit(false);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              })
            }
            onSelectionChange={(rows, row) => {
              if (row?.tableData?.checked) {
                // setSelectedRows([
                //   ...selectedRows,
                //   {
                //     ...row,
                //     key: "new",
                //     tableData: { ...row.tableData, id: row.roleName },
                //   },
                // ]);
                if (tempSelectedRows) {
                  const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                  arr.push({
                    ...row,
                    key: 'new',
                    tableData: {...row.tableData, id: row.roleName},
                  });
                  setTempSelectedRows(arr);
                }
              } else {
                // const newDel = [...deletedIds];
                // fetchedData.map((i) => {
                //   if (i.roleId === row?.roleId) {
                //     newDel.push(row?.roleId);
                //     setDeletedIds(newDel);
                //   }
                // });
                tempUnCheckedRef.current.push(row);
                const updatedRows = [...tempSelectedRows]
                  .filter((ele) => ele?.roleId !== row?.roleId)
                  .map((ele) => {
                    return {...ele, tableData: {...ele.tableData, id: ele.roleName}};
                  });
                setTempSelectedRows(updatedRows);
              }
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleCopy={handleCopy}
                  hiddenMenu={{
                    edit: false,
                    copy: false,
                    notes: false,
                    hiddenDelete: true,
                    execution: true,
                    run: true,
                    usage: true,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: !roleAccess?.edit,
                    disableCopy: !roleAccess?.add,
                    disableNotes: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableRun: false,
                    disableDelete: false,
                    disableExecution: false,
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {!isAddUser && (
                      <Button
                        type="button"
                        variant="outlined"
                        className={`search-btn`}
                        disabled={!roleAccess?.add}
                        onClick={(event) => {
                          setValue(1);
                        }}
                        startIcon={<AddIcon />}
                      >
                        Add Role
                      </Button>
                    )}
                  </div>
                </div>
              ),
            }}
            actions={
              // !isAddUser && [
              //   {
              //     // Added Add/View button in table header for routing (2700799562)
              //     icon: () => (
              //       <>
              //         <Button
              //           type="button"
              //           variant="outlined"
              //           className={`search-btn`}
              //           disabled={!roleAccess?.add || dataCount === 0}
              //         >
              //           Add Role
              //         </Button>
              //       </>
              //     ),
              //     disabled: !roleAccess?.add,
              //     isFreeAction: true,
              //     onClick: (event) => {
              //       setValue(1);
              //     },
              //   },
              //   {
              //     icon: () => <EditOutlinedIcon />,
              //     tooltip: "Edit",
              //     disabled: !roleAccess?.edit,
              //     // hidden: StepperFieldList,
              //     onClick: (event, rowData) => {
              //       dispatch(fetchAddRoleData(rowData.roleId));
              //       setRoleId(rowData.roleId);
              //       setValue(1);
              //       const moduleArr = rowData?.moduleName?.split(",");
              //       let newModuleArr = moduleArr?.map((data) => data.trim());
              //       const finArr = newModuleArr.map((each) => {
              //         if (each === "Business Rule Engine") {
              //           return "Business Rule Engine";
              //         } else if (each === "Custom WIndow") {
              //           return "Custom Window";
              //         } else {
              //           return each;
              //         }
              //       });
              //       rowData?.moduleName !== "null" && setModuleNames(finArr);
              //     },
              //   },
              //   {
              //     icon: () => (
              //       <>
              //         <FileCopyOutlinedIcon />
              //       </>
              //     ),
              //     tooltip: "Copy",
              //     disabled: !roleAccess?.add,
              //     onClick: (event, rowData) => {
              //       dispatch(fetchAddRoleData(rowData.roleId));
              //       setRoleId(rowData.roleId);
              //       setValue(1);
              //       setIsCopy(true);
              //       const moduleArr = rowData?.moduleName?.split(",");
              //       let newModuleArr = moduleArr?.map((data) => data.trim());
              //       const finArr = newModuleArr.map((each) => {
              //         if (each === "Business Rule Engine") {
              //           return "Business Rule Engine";
              //         } else if (each === "Custom WIndow") {
              //           return "Custom Window";
              //         } else {
              //           return each;
              //         }
              //       });
              //       rowData?.moduleName !== "null" && setModuleNames(finArr);
              //     },
              //   },

              //   {
              //     icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
              //     tooltip: "Role Management Notes",
              //     onClick: (event, rowData) => {
              //       setIsNote(true);
              //       setRoleName(rowData?.roleName);
              //     },
              //   },
              // ]
              !isAddUser && [
                {
                  icon: () => <SaveIcon />,
                  tooltip: 'Save User',
                  onClick: (event, rowData) => console.log(rowData, 'rowData'),
                },
              ]
            }
            options={{
              search: false,
              toolbar: !isAddUser,
              pageSize: rows,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              selection: isAddUser,
              selectionProps: (rowData) => {
                let disabledFields = false;
                if (rowData.isActive === 'N') {
                  disabledFields = true;
                }
                return {
                  disabled: disabledFields,
                };
              },
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
          />
        </div>
      </Grid>
    </>
  );
};

export default RoleManagementTable;
